"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var field_1 = require("../../../../components/pricing/layout/field/field");

var label_1 = require("../../../../components/pricing/text/label/label");

var constants_1 = require("../../../../theming/pricing-system/constants");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var TextInputField = function (_super) {
  __extends(TextInputField, _super);

  function TextInputField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      value: ''
    };

    _this.clear = function () {
      _this.setState({
        errorMessage: undefined,
        value: ''
      });
    };

    _this.validate = function () {
      var isValid = _this.onChangeText(_this.state.value);

      return isValid ? _this.state.value : '';
    };

    _this.onChangeText = function (text) {
      var isValid = _this.isValid(text);

      var errorMessage = isValid ? undefined : _this.invalidInputMessage;

      _this.setState({
        errorMessage: errorMessage,
        value: text
      });

      return isValid;
    };

    _this.onBlur = function () {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        onSelect(_this.state.errorMessage ? '' : _this.state.value);
      }
    };

    return _this;
  }

  TextInputField.prototype.componentDidMount = function () {
    var value = this.props.value || '';
    this.setState({
      value: value
    });
  };

  TextInputField.prototype.render = function () {
    var keyboardType = this.props.keyboardType ? this.props.keyboardType : 'default';
    var inputTextStyle = this.state.errorMessage ? theme_pricing_system_1.pricingStyles.priceLookupTextInputErrorStyle : theme_pricing_system_1.pricingStyles.priceLookupTextInputStyle;
    return react_1.default.createElement(field_1.Field, {
      viewStyle: this.props.viewStyle,
      errorMessage: this.state.errorMessage
    }, react_1.default.createElement(label_1.Label, {
      label: this.props.label
    }, react_1.default.createElement(react_native_1.TextInput, {
      style: inputTextStyle,
      keyboardType: keyboardType,
      onChangeText: this.onChangeText,
      onBlur: this.onBlur,
      value: this.state.value,
      editable: !this.props.isDisabled
    })));
  };

  TextInputField.prototype.isValid = function (text) {
    var validator = this.props.onValidate;
    return validator ? validator(text) : true;
  };

  Object.defineProperty(TextInputField.prototype, "invalidInputMessage", {
    get: function get() {
      return this.props.invalidInputMessage ? this.props.invalidInputMessage : constants_1.TextInputFieldContent.invalidInputMessage;
    },
    enumerable: true,
    configurable: true
  });
  return TextInputField;
}(react_1.default.PureComponent);

exports.TextInputField = TextInputField;